import Swal from 'sweetalert2';

export class Modals {

  public static viewModalError(title: string, text: string){
    Swal.fire({
      icon: 'error',
      title,
      text
    });
  }

  public static viewModalSuccess(title: string, text: string){
    Swal.fire({
      icon: 'success',
      title,
      text
    });
  }

  public static viewModalWarning(title: string, text: string){
    Swal.fire({
      icon: 'warning',
      title,
      text
    });
  }

  public static viewModalDowndload(title: string, text: string){
    Swal.fire({
      title,
      text,
      timerProgressBar: true,
      onBeforeOpen: () => {
          Swal.showLoading()
      },
      allowOutsideClick: false
    });
  }

  public static closeModal() {
    Swal.close()
  }
}
